<template>
  <div class="card mb-4">
    <div class="card-body pb-3 d-flex flex-wrap">
      <oms-filter-statuses
        :title="t('features.vue.shipment_boxes.filters.order_type')"
        icon="ri-ship-line"
        :statuses="shipmentBoxTypes"
        v-model="filters.shipment_box_types"
        color="secondary"
      />
      <oms-filter-statuses
        :title="t('features.vue.shipment_boxes.filters.events')"
        icon="ri-ship-line"
        :statuses="events"
        v-model="filters.events"
        color="secondary"
      />
      <oms-filter-date-range
        :title="t('features.vue.shipment_boxes.filters.picked_up_at')"
        icon="ri-map-pin-time-line"
        v-model="filters.picked_up_at"
      />
      <oms-filter-date-range
        :title="t('features.vue.shipment_boxes.filters.left_japan_at')"
        icon="ri-map-pin-time-line"
        v-model="filters.left_japan_at"
      />
      <oms-filter-date-range
        :title="t('features.vue.shipment_boxes.filters.transacted_at')"
        icon="ri-map-pin-time-line"
        v-model="filters.transacted_at"
      />
      <oms-filter-date-range
        :title="t('features.vue.shipment_boxes.filters.cancelled_at')"
        icon="ri-map-pin-time-line"
        v-model="filters.cancelled_at"
      />
      <oms-filter-date-range
        :title="t('features.vue.shipment_boxes.filters.returned_at')"
        icon="ri-map-pin-time-line"
        v-model="filters.returned_at"
      />
      <oms-filter-date-range
        :title="t('features.vue.shipment_boxes.filters.delivered_at')"
        icon="ri-map-pin-time-line"
        v-model="filters.delivered_at"
      />
   
      <oms-filter-ids :title="t('features.vue.orders.filters.tracking_numbers')" icon="ri-truck-line" v-model="filters.tracking_numbers" />

      <div class="form-inline mr-2 mb-2 ml-auto" :title="t('features.vue.shipment_boxes.filters.search_placeholder')">
        <input
          class="form-control"
          v-model="filters.keyword"
          @keyup.enter="submit"
          type="text"
          :placeholder="t('features.vue.shipment_boxes.filters.search_placeholder')"
        />
      </div>

      <button class="btn btn-primary mr-2 mb-2" @click="submit" :disabled="isLoading || !isDirty">
        <span class="ri-search-line"></span> {{ t('features.vue.common.search') }}
      </button>

      <button class="btn btn-primary mr-2 mb-2" @click="exportCsv" :disabled="isLoading">
        <span class="ri-download-line"></span> {{ t('features.vue.common.export_csv') }}
      </button>

      <div v-if="selectedBoxes.size" class="w-100 d-flex justify-content-end align-items-center gap-3">
        <span>{{ t('features.vue.shipment_boxes.filters.orders_selected', { count: selectedBoxes.size }) }}</span>
        <button v-if="filters.shipment_name" :disabled="isLoading" data-action="shipment-boxes-index#deleteOrder" class="btn btn-danger">        
          {{ t('features.vue.shipment_boxes.filters.remove_orders') }}
        </button>
      </div>
    </div>

 
    <div class="card-body pt-0 pb-1">
      <oms-filter-content-statuses
        :title="t('features.vue.shipment_boxes.filters.order_type')"
        :statuses="shipmentBoxTypes"
        v-model="filters.shipment_box_types"
        color="secondary"
      />
      <oms-filter-content-statuses
        :title="t('features.vue.shipment_boxes.filters.events')"
        :statuses="events"
        v-model="filters.events"
        color="secondary"
      />
      <oms-filter-content-date-range :title="t('features.vue.shipment_boxes.filters.picked_up_at')" :modelValue="filters.picked_up_at" />
      <oms-filter-content-date-range :title="t('features.vue.shipment_boxes.filters.left_japan_at')" :modelValue="filters.left_japan_at" />
      <oms-filter-content-date-range :title="t('features.vue.shipment_boxes.filters.transacted_at')" :modelValue="filters.transacted_at" />
      <oms-filter-content-date-range :title="t('features.vue.shipment_boxes.filters.cancelled_at')" :modelValue="filters.cancelled_at" />
      <oms-filter-content-date-range :title="t('features.vue.shipment_boxes.filters.returned_at')" :modelValue="filters.returned_at" />
      <oms-filter-content-date-range :title="t('features.vue.shipment_boxes.filters.delivered_at')" :modelValue="filters.delivered_at" />
      <oms-filter-content-basic :title="t('features.vue.shipment_boxes.filters.shipment')" :modelValue="filters.shipment_name" />
      
      <oms-filter-content-basic
        :title="t('features.vue.shipment_boxes.filters.shipment_invoice')"
        :modelValue="filters.shipment_invoice_name"
      />
      <oms-filter-content-basic
        :title="t('features.vue.shipment_boxes.filters.geps_awb')"
        :modelValue="filters.geps_awb_id"
      />
    </div>
  </div>
</template>


<script>
import buildQueryString from '../../../helpers/query-builder'
import OmsFilterStatuses from '../filter/statuses.vue'
import OmsFilterRadioButtons from '../filter/radio-buttons.vue'
import OmsFilterDateRange from '../filter/date-range.vue'
import OmsFilterContentDateRange from '../filter-content/date-range.vue'
import OmsFilterContentStatuses from '../filter-content/statuses.vue'
import OmsFilterContentBasic from '../filter-content/basic.vue'
import OmsFilterIds from '../filter/ids.vue'
export default {
  inject: ['i18n'],

  props: {
    initialData: Object
  },
  data() {
    return {
      ...this.initialData,
      isLoading: false,
      selectedBoxes: new Set(),
      isDirty: false
    }
  },

  computed: {
    searchUrl() {
      return `${this.baseUrl}?${this.filterQueryString}`
    },

    filterQueryString() {
      return buildQueryString(this.filters, 'q')
    }
  },

  watch: {
    filters: {
      deep: true,
      handler() {
        this.isDirty = true
      }
    }
  },

  methods: {
    t(key, options) {
      return this.i18n ? this.i18n.t(key, options) : key
    },

    submit() {
      this.isDirty = false
      this.isLoading = true

      window.location.href = this.searchUrl
    },

    exportCsv() {
      if (!confirm(this.t('features.vue.shipment_boxes.filters.export_csv_confirm'))) return

      const form = document.createElement('form')
      form.method = 'POST'
      form.action = `${this.exportUrl}?${this.filterQueryString}`

      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      if (csrfToken) {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = 'authenticity_token'
        input.value = csrfToken
        form.appendChild(input)
      }

      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
    }
  },

  created() {
    this.$bus.on('checkboxChanged', ({ id, checked }) => {
      if (checked) {
        this.selectedBoxes.add(id);
      } else {
        this.selectedBoxes.delete(id);
      }
    });
  },

  components: {
    OmsFilterStatuses,
    OmsFilterRadioButtons,
    OmsFilterDateRange,
    OmsFilterContentDateRange,
    OmsFilterContentStatuses,
    OmsFilterContentBasic,
    OmsFilterIds
  }
}
</script>
